import React from "react";
import DrawerTitle from "../Drawer/DrawerTitle";
import { AllTabType } from "src/types/GlobalInterfaces";
import NotificationStatus from "../Customer/NotificationStatus";
import PrimaryBtn from "../GlobalComponents/primaryBtn";
import GradientBtn from "../WebsiteComponents/GradientBtn";

interface IProps {
  onBack?: () => void;
  setActiveTab?: (tab: AllTabType) => void;
  onClose?: () => void;
}

const ManageNotificationsScreen = ({ onBack, setActiveTab, onClose }: IProps) => {
  return (
    <>
      <DrawerTitle
        title="Manage Notifications"
        onBack={onBack}
        backBtn
        id="back-button"
      />
      <div className="p-2 2xl:p-3 gap-2 2xl:gap-4">
        <NotificationStatus />
      </div>
    </>
  );
};

export default ManageNotificationsScreen;
